module.exports = __webpack_public_path__ + "img/calculator.e9c66729.svg";